import React from 'react'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Grid2,Typography} from "@mui/material";
import Slider from "react-slick";
import "../Home.css"
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

export function HomePopularDesktop(){
  
  const imgData = ["pepper", "star", "allspices", "allspies","SpicesPowder","Star-Anise","Ginger","SpicesCombo","MainSpices","cardamom","Cloves","Raw-Pepper","cinnamon","fenugreek","RedChilli","GreenChilli","Rice","ChittiMuthuallu","BengalGram","PigeonPeas","GreenGram","BlackGram","Chickpeas","KidneyBeans","RedLentils"]
  
  const settings = {
        dots: true, infinite: true, speed: 500, slidesToShow: 4, slidesToScroll: 1, initialSlide: 0,autoplay: true,autoplaySpeed: 2000,
        nextArrow :<KeyboardArrowRightIcon sx={{display:"block !important",fontSize:"70px !important",color:"#fff",zIndex:"999",right:"0px !important","&:hover":{color:"#000"}}}/>,
        prevArrow :<KeyboardArrowLeftIcon sx={{fontSize:"70px !important", color:"#fff",zIndex:"999",left:"0px !important","&:hover":{color:"#000"}}}/>,
        responsive: [
          { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3, infinite: false, dots: false } },
          { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2, initialSlide: 2, dots: false } },
          { breakpoint: 480, settings: { slidesToShow: 2, slidesToScroll: 1, dots: false } }
        ]
      };
  return (

    <Grid2 className="info" container justifyContent="center" sx={{width:"100%",position:"relative",gap:"20px"}}>
        <Typography className="headingdata">Our Products range</Typography>
        <Grid2 width="100%">
            <Grid2 container sx={{"& .slick-slider" : {width:"100%"},justifyContent:"space-between",gap:"20px"}}>
                <Slider {...settings} >
                 {imgData?.map((item,i) => {
                    return(
                            <Grid2 key={i} container className="Card" sx={{width:"99% !important"}}>
                              <Grid2 container className="imgcontainer" height="90%" width="100%" >
                                <img src={require(`../../../assets/Home/${item}.jpg` )} alt={item} style={{ objectFit: "cover", width: "95%", height: "95%", borderRadius: "12px" }}  />
                              </Grid2>
                              <Typography className="Cardtext" textAlign="center">{item}</Typography>
                            </Grid2>
                 )})}
                </Slider> 
            </Grid2>
        </Grid2>
      </Grid2>
    
  )
}

 